export const product_status = [
  { code: 0, label: 'inactive'},
  { code: 1, label: 'active'},
  { code: 2, label: 'onSale'},
];